export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m23 21.5-11-19-11 19zm-12-3v-2h2v2zm0-4v-4h2v4z\"/>"
};